import { CardStack } from "../../components/card-stack";
import { Element } from 'react-scroll';
import { cn } from "../../lib/utils";


const Feature2 = () => {
  return (
    <Element name="component3" className="component lg:h-[100vh] sm:h-[100vh]">
      <div className="grid grid-cols-12 gap-4">
        <div className="lg:col-span-1 sm:col-span-12 p-2 flex items-center justify-center">
        </div>
        <div className="lg:col-span-5 sm:col-span-12 p-2 flex items-center justify-center">
          <div className="h-[40rem] flex items-center justify-center w-full sm:h-1/2">
             <CardStack items={CARDS} />
          </div>
        </div>
        <div className="lg:col-span-5 sm:col-span-12 lg:p-2 sm:pr-2 sm:pl-2 flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center w-full sm:w-3/4">
          <div className="text-4xl text-custom-blue lg:text-left sm:text-center">
              A review sytem, which just works
          </div>
          <div className="text-1_5xl text-custom-blue pt-7 text-left">
            With traveler being the core of the platform, always rely on our personalised review sytem to find you the knowledge that suits your taste, is from authentic people, and will make sense to you
          </div>
          <div className="text-1_5xl text-custom-blue pt-7 text-left italic">
            In short, you know the chemistry, and let Hop know the business
          </div>
          </div>
        </div>
        <div className="lg:col-span-1 sm:col-span-12 p-2 flex items-center justify-center">
        </div>
      </div>
    </Element>
  );
}

// Small utility to highlight the content of specific section of a testimonial content
const Highlight = ({
  children,
  className
}) => {
  return (
    (<span
      className={cn(
        "font-bold bg-emerald-100 text-emerald-700 dark:bg-emerald-700/[0.2] dark:text-emerald-500 px-1 py-0.5",
        className
      )}>
      {children}
    </span>)
  );
};

const CARDS = [
  {
    id: 0,
    name: "Amit Sharma",
    designation: "doesn't bother to provide",
    content: (
      <p>
        Gujarat was great during January. The <Highlight>Rann of Kutch</Highlight>
        was as beautiful as ever. Reaching there was bit of a work, but the journey
        was definitely worth it. 🙏
      </p>
    ),
  },
  {
    id: 1,
    name: "Nadia",
    designation: "Designer by title",
    content: (
      <p>
        Going to Goa during summer was such a waste of time,{" "}
        <Highlight>DO NOT GO THERE DURING SUMMERS</Highlight> Period.
        The resorts, the outdoors, the beaches, everything was just too hot to handle.
      </p>
    ),
  },
  {
    id: 2,
    name: "Anna S.",
    designation: "Something something manager",
    content: (
      <p>
        If you love Christmas and you're not in Europe, Pondicherry is the place to be.
        The French architecture, the churches, the beaches, everything is just so
        beautiful during the festive season. <Highlight>Highly recommended</Highlight>.
      </p>
    ),
  },
];


export default Feature2